import React, {useState} from "react";
import {Modal, Tabs} from "antd";
import CreateRequestForm from "components/equipments/equipmentRequests/modals/createRequestModal/CreateRequestForm";
import MyEquipmentRequestsTab from "./MyEquipmentRequestsTab";

const {TabPane} = Tabs;

const EquipmentRequestModal = ({visible, onClose}) => {
    const [requestsRecall, setRequestsRecall] = useState(false);

    return (
        <Modal
            title="Yeni Ekipman Talebi"
            visible={visible}
            onCancel={onClose}
            width={1000}
            footer={null}
            // Kapanışta içerik unmount edilir; her açılış temiz form ve güncel liste ile başlar.
            destroyOnClose
        >
            <Tabs defaultActiveKey="createRequest">
                <TabPane tab="Ekipman Talep Et" key="createRequest">
                    <CreateRequestForm
                        onClose={onClose}
                        recall={() => setRequestsRecall(prev => !prev)}
                    />
                </TabPane>
                <TabPane tab="Taleplerim" key="myRequests">
                    <MyEquipmentRequestsTab recall={requestsRecall} />
                </TabPane>
            </Tabs>
        </Modal>
    );
};

export default EquipmentRequestModal;
